"use client";

import { useTranslation } from "react-i18next";
import { ChartProductCompetencyTooltipProps, SeriesItem } from "../types";

export function ChartProductCompetencyTooltip({
  active,
  payload,
  label,
  series,
  displayMode,
  isDaily,
}: ChartProductCompetencyTooltipProps) {
  const [translate] = useTranslation(["dashboard"]);
  if (!active || !payload?.length) return null;
  const data = payload[0].payload;
  const originalData = data?.originalData || [];
  const longLabel = data?.longLabel || label;
  const periodLabel = isDaily ? `Dia ${label}` : longLabel;

  return (
    <div className="bg-white border border-ligtgray-400 rounded-2xl min-w-[180px]">
      <div className="font-normal text-darkgray-900 mb-3 pb-2 bg-lightgray-400 rounded-t-2xl p-4 text-center capitalize">
        {periodLabel}
      </div>
      <div className="space-y-2 p-4">
        {series.map((s: SeriesItem) => {
          const item = originalData.find((b: any) => b.type === s.type);
          const raw =
            displayMode === "currency"
              ? parseFloat(item?.monetary_value ?? "0")
              : Number(item?.credits_value ?? 0);
          const value = Number.isFinite(raw) ? raw : 0;

          const formatted =
            displayMode === "currency"
              ? `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
              : value.toLocaleString("pt-BR", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                });

          return (
            <div key={s.key} className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full bg-${s.color}`} />
              <span className="text-sm text-darkgray-800 font-normal">
                {translate(s.label)}: {formatted}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
